import { ComponentRef, Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { PopoverPlacement } from '@frontendlib/components/features/popover/types/placement';
import type { PopoverTrigger } from '@frontendlib/components/features/popover/types/trigger';
import { startWith, takeUntil } from 'rxjs/operators';
import { SheetFoldersListContextMenuComponent } from '../components/sheet-folders-list-context-menu/sheet-folders-list-context-menu.component';
import { SheetFolderListStateService } from '../services/sheet-folder-list-state.service';

@Directive({
  selector: '[appSheetFoldersListContextMenu]',
  standalone: false,
})
export class SheetFoldersListContextMenuDirective extends ContextMenuDirective implements OnInit, OnDestroy {
  @Input()
  public appSheetFoldersListContextMenuWithAdvancedSearch: boolean;
  @Input()
  public appSheetFoldersListContextMenuWithScore: boolean;
  @Input()
  public stchPopoverTrigger: PopoverTrigger = 'click';
  @Input()
  public stchPopoverPlacement: PopoverPlacement = 'bottomLeft';

  private readonly sheetFolderListStateService = inject(SheetFolderListStateService);

  public registerInstance(componentRef: ComponentRef<SheetFoldersListContextMenuComponent>) {
    componentRef.instance.state = this.sheetFolderListStateService.state;
    componentRef.instance.withAdvancedSearch = this.appSheetFoldersListContextMenuWithAdvancedSearch;
    componentRef.instance.withScore = this.appSheetFoldersListContextMenuWithScore;
  }

  public registerComponent() {
    return SheetFoldersListContextMenuComponent;
  }

  public override ngOnInit() {
    super.ngOnInit();

    this.sheetFolderListStateService.state
      .changes()
      .pipe(startWith(null), takeUntil(this.alive))
      .subscribe(() => {
        this.isDefaultStateObservable?.next(this.sheetFolderListStateService.state.isDefault());
      });

    if (!this.isDefaultStateObservable) {
      return;
    }

    this.isDefaultStateObservable.pipe(takeUntil(this.alive)).subscribe((isDefault) => {
      if (isDefault && !this.sheetFolderListStateService.state.isDefault()) {
        this.sheetFolderListStateService.state.resetToDefault();
      }
    });
  }
}
